import axios from "axios";
import { getAuthHeaders } from "../helpers";

/**
 * @function getAuditTrails
 * @param startDate - Start date for audit trail fetch (YYYY-MM-DD format)
 * @param endDate - End date for audit trail fetch (YYYY-MM-DD format,
 * optional)
 * @param page - Page number for pagination (optional, defaults to 1)
 * @param filters - Filter object containing clinic_id, user_type,
 * event_status, resource_type, search, etc.
 * @description This function will fetch audit trails from the admin API
 */
export const getAuditTrails = (
  startDate,
  endDate = null,
  page = 1,
  filters = {}
) => {
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  let url = `${baseUrl}/admin/audit_trails?start_date=${startDate}`;

  if (endDate) {
    url = `${url}&end_date=${endDate}`;
  }

  if (page && page > 1) {
    url = `${url}&page=${page}`;
  }

  // Add filter parameters
  Object.keys(filters).forEach(key => {
    if (filters[key] && filters[key] !== "") {
      url = `${url}&${key}=${encodeURIComponent(filters[key])}`;
    }
  });

  const headers = getAuthHeaders();
  return axios.get(url, { headers });
};

/**
 * @function getAuditTrailSummary
 * @param startDate - Start date for summary (YYYY-MM-DD format)
 * @param endDate - End date for summary (YYYY-MM-DD format, optional)
 * @param clinicId - Optional clinic ID to filter summary
 * @description This function will fetch audit trail summary from the
 * admin API
 */
export const getAuditTrailSummary = (
  startDate,
  endDate = null,
  clinicId = null
) => {
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  let url = `${baseUrl}/admin/audit_trails/summary`;

  const params = [];
  if (startDate) params.push(`start_date=${startDate}`);
  if (endDate) params.push(`end_date=${endDate}`);
  if (clinicId) params.push(`clinic_id=${clinicId}`);

  if (params.length > 0) {
    url = `${url}?${params.join("&")}`;
  }

  const headers = getAuthHeaders();
  return axios.get(url, { headers });
};
